import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const PlayerSelector = ({ players, selectedPlayer, onSelect, type }) => (
  <TextField select fullWidth label={type} value={selectedPlayer} onChange={(e) => onSelect(e.target.value)}>
    {players.map((player) => (
      <MenuItem key={player.user_name} value={player.user_name}>
        {player.user_name}
      </MenuItem>
    ))}
  </TextField>
);

export default PlayerSelector;
